class WizardComponent extends HTMLElement {
    constructor() {
        super();

        this.handleStepButtonClick = this.handleStepButtonClick.bind(this);
    }

  get activeStep() {
    if (!this.stage) {
      return null;
    }

    return this.stage.querySelector("[data-wizard-active-step]");
  }

  get stepCount() {
    return this.steps.length;
  }


  connectedCallback() {
    this.getEls();

    if (!this.stage || this.stepCount === 0) {
      return;
    }

    this.addListeners();
    this.syncStepButtonActiveState();
    this.syncStepAriaHidden();
  }

  getEls() {
    this.stage = this.querySelector("[data-wizard-stage]");
    this.steps = this.querySelectorAll("[data-wizard-step]");
    this.stepButtons = this.querySelectorAll("[data-wizard-step-button]");
  }


  addListeners() {
    this.stepButtons.forEach((button) => {
      button.addEventListener("click", this.handleStepButtonClick);
    });
  }

  handleStepButtonClick(event) {
    const button = event.currentTarget;
    const stepIndex = parseInt(button.getAttribute("data-wizard-step-button"), 10);

    if (Number.isNaN(stepIndex)) {
      return;
    }

    this.handleStepClick(stepIndex);
  }

  handleStepClick(stepIndex) {
    this.goToStep(stepIndex);
  }

  /** @param {number} stepIndex Matches [data-wizard-step] (1-based). */
  goToStep(stepIndex) {
    const currentStep = this.activeStep;
    const nextStep = this.getStep(stepIndex);

    if (currentStep && nextStep && currentStep !== nextStep) {
      currentStep.removeAttribute("data-wizard-active-step");
      nextStep.setAttribute("data-wizard-active-step", "true");
      this.syncStepAriaHidden();
      this.syncStepButtonActiveState();

      this.closeAllDetails();
    }
  }

  syncStepAriaHidden() {
    if (!this.stage) {
      return;
    }

    this.steps.forEach((step) => {
      if (step.hasAttribute("data-wizard-active-step")) {
        step.removeAttribute("aria-hidden");
      } else {
        step.setAttribute("aria-hidden", "true");
      }
    });
  }

  syncStepButtonActiveState() {
    if (!this.stage) {
      return;
    }

    const activeStepEl = this.activeStep;
    const activeIndex = activeStepEl
      ? parseInt(activeStepEl.getAttribute("data-wizard-step"), 10)
      : NaN;

    const indicatorButtons = this.stage.querySelectorAll(
      "[data-wizard-step-indicator]"
    );

    indicatorButtons.forEach((button) => {
      const buttonStep = parseInt(
        button.getAttribute("data-wizard-step-button"),
        10
      );

      if (
        !Number.isNaN(activeIndex) &&
        !Number.isNaN(buttonStep) &&
        buttonStep === activeIndex
      ) {
        button.setAttribute("data-wizard-step-button-active", "");
      } else {
        button.removeAttribute("data-wizard-step-button-active");
      }
    });
  }

  closeAllDetails() {
    const details = this.querySelectorAll('details');
    details.forEach((detail) => {
      detail.removeAttribute('open');
    });
  }

  removeListeners() {
    this.stepButtons.forEach((button) => {
      button.removeEventListener("click", this.handleStepButtonClick);
    });
  }

  disconnectedCallback() {
    this.removeListeners();
  }

  getStep(index) {
    if (!this.stage) {
      return null;
    }

    return this.stage.querySelector(`[data-wizard-step="${index}"]`);
  }
}

if (!customElements.get("wizard-component")) {
  customElements.define("wizard-component", WizardComponent);
}
